import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import EmailVerifyBanner from '../../../assets/images/register/otp-verify-banner.png';
import { useAppDispatch } from '../../../redux/hooks';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '../../../shared-functions/LocalStorage';
import { passwordValidation } from '../../../shared-functions/Validation';
import auth from '../../../utils/api/auth';

import OtpVerifyBanner from './OtpVerifyBanner';

/**
 * Login Component
 */
function PasswordReset({ token }: { readonly token: string | undefined }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const passwordResetDetails = getLocalStorageItem('passwordReset');
  const [credentials, setCredentials] = useState<{
    password: string;
    confirmPassword: string;
  }>({
    password: '',
    confirmPassword: '',
  });

  const [formStatus, setFormStatus] = useState({
    showFormErrors: false,
    hint: true,
    buttonLoader: false,
  });

  /**
   * Get input change value and store in credentials state
   * @param name
   * @param changeValue
   */
  const handleCredentialChange = (name: string, changeValue: string | number) => {
    setCredentials({
      ...credentials,
      [name]: changeValue,
    });
  };

  /**
   * Function to submit entered cre
   */
  const handleSubmit = () => {
    setFormStatus({
      showFormErrors: true,
      hint: false,
      buttonLoader: false,
    });
    if (
      passwordValidation(credentials.password) &&
      credentials.password === credentials.confirmPassword
    ) {
      setFormStatus({
        showFormErrors: true,
        hint: false,
        buttonLoader: true,
      });

      let requestBody = {};
      if (!token) {
        requestBody = {
          countryCode: passwordResetDetails.countryCode,
          accountCustomId: passwordResetDetails.accountCustomId
            ? passwordResetDetails.accountCustomId
            : undefined,
          emailOrPhoneNumber: passwordResetDetails.emailOrPhoneNumber,
          otp: passwordResetDetails.otp,
          newPassword: credentials.password,
        };
      } else {
        requestBody = {
          token,
          newPassword: credentials.password,
        };
      }

      const action = token ? auth.resetPasswordToken(requestBody) : auth.resetPassword(requestBody);

      action
        .then(() => {
          navigate('../login/credentials');
          removeLocalStorageItem('passwordReset');
          setFormStatus({
            showFormErrors: false,
            hint: false,
            buttonLoader: false,
          });
        })
        .catch((error) => {
          console.error('Login attempt failed:', error);
          setFormStatus({
            showFormErrors: false,
            hint: false,
            buttonLoader: false,
          });
          // Display a user-friendly message
          dispatch(
            setNotificationDetails({
              type: 'error',
              notificationDetails: {
                statusCode: error?.response?.data?.code || 200,
                message: error?.response?.data?.message || 'Something went wrong!',
              },
            }),
          );
        });
    }
  };

  useEffect(() => {
    if (!passwordResetDetails && !token) {
      navigate('../login/forgot-password');
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-banner-container">
        <OtpVerifyBanner
          imageSrc={EmailVerifyBanner}
          bannerTittle="Enter the OTP"
          bannerDescription="Please enter the OTP. Received that which you registered phone number / email id"
        />
      </div>
      <div className="login-form-container">
        <div className="login-form">
          <h1>Create password</h1>
          <CustomInput
            inputLabel="Create New Password"
            type="password"
            placeholder="Enter password"
            name="password"
            value={credentials.password}
            onChangeValue={handleCredentialChange}
            error={!passwordValidation(credentials.password) && formStatus.showFormErrors}
            errorMessage="Password must be at least 12 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character."
            hint={credentials.password.length === 0 || !passwordValidation(credentials.password) ? formStatus.hint : false}
            hintMessage='Password must be 12+ characters, with at least 1 uppercase, 1 lowercase, 1 number, and 1 special character( ! @ # $ % ^ & * ( ) _ + [ \ ] { } ; &apos; : &quot; \\ | , . < > / ? ~ - ).'
          />
          <CustomInput
            inputLabel="Confirm Password"
            type="password"
            placeholder="Enter password"
            name="confirmPassword"
            value={credentials.confirmPassword}
            onChangeValue={handleCredentialChange}
            error={
              !(credentials.password === credentials.confirmPassword) && formStatus.showFormErrors
            }
            errorMessage="Password & Confirm password should be same."
          />
          <MyButton
            label="Submit"
            buttonType="submit"
            onClickFunc={handleSubmit}
            loading={formStatus.buttonLoader}
            disableButton={formStatus.buttonLoader}
          />
        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
